'use client';

import dynamic from 'next/dynamic';

// AiChatWidget (MUI + markdown renderer + its own chat hook) was previously imported
// eagerly into MainLayout (the root layout), shipping its JS in the main bundle for
// every page and every user — including guests, even though it self-gates to
// authenticated users at render time. Deferring it via next/dynamic keeps that same
// self-gating behavior but only loads/parses/hydrates its code when actually needed.
export const AiChatWidget = dynamic(
  () => import('./AiChatWidget').then((mod) => mod.AiChatWidget),
  { ssr: false },
);
